// extracted by mini-css-extract-plugin
export default {"container":"LockScreenLayout_container__2gisp","gradientAnimation":"LockScreenLayout_gradientAnimation__ej3mu","body":"LockScreenLayout_body__vEv2q"};